import { render, staticRenderFns } from "./cookie-banner-installation-step.vue?vue&type=template&id=45b2e05a"
import script from "./cookie-banner-installation-step.vue?vue&type=script&lang=js"
export * from "./cookie-banner-installation-step.vue?vue&type=script&lang=js"
import style0 from "./cookie-banner-installation-step.vue?vue&type=style&index=0&id=45b2e05a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports